import {Injectable, Injector} from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import {AuthService} from '../auth.service';
import {AuthRefreshService} from '../auth-refresh.service';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import {environment} from '../../../environments/environment';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(private _injector: Injector) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const auth = this._injector.get(AuthService);

    // The refresh call carries the cookie, not a bearer; never decorate or 401-handle it.
    if (request.url.indexOf(environment.refreshUrl) !== -1) {
      return next.handle(request);
    }

    const authed = request.clone({
      setHeaders: {
        Authorization: `Bearer ${auth.token()}`,
        [environment.apiKey]: environment.apiKeyValue,
        'context': 'User'
      }
    });

    return next.handle(authed).catch((err: any) => {
      if (err instanceof HttpErrorResponse && err.status === 401 && !request.headers.has('X-Auth-Retry')) {
        const refresher: AuthRefreshService = this._injector.get(AuthRefreshService);
        return refresher.handle401(() => {
          const retried = request.clone({
            setHeaders: {
              Authorization: `Bearer ${auth.token()}`,
              [environment.apiKey]: environment.apiKeyValue,
              'context': 'User',
              'X-Auth-Retry': '1'
            }
          });
          return next.handle(retried);
        });
      }
      return Observable.throw(err);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/interceptors/token.interceptor.ts